import { httpPost } from "../../../../../../../Utils/apis/apis";

export const submitPaymentDetails = async (isEditMode, payload) => {
  const latestData = {
    spName: isEditMode ? "DF.usp_EditPaymentDetails" : "DF.usp_AddPaymentDetails",
    parameters: { parametersAsJsonString: JSON.stringify(payload) },
  };
  return httpPost(`/SQLBasedForm/SQLFormOperations`, latestData, "", true);
};
